import { SHOW_ERROR, CLEAR_ERROR } from "./ErrorBoundaryActions";
import { AppError } from "../../Types/AppError";

type ErrorState = {
  error: AppError | null;
};

const initialState: ErrorState = {
  error: null,
};

export default function ErrorBoundaryReducer(
  state = initialState,
  action: any
): ErrorState {
  switch (action.type) {
    case SHOW_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}
